import * as React from "react";
import type { SVGProps } from "react";
const SvgHelpCircleContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.999 16.8v.042M9.6 9.045C9.6 7.695 10.675 6.6 12 6.6c1.326 0 2.4 1.095 2.4 2.445s-1.075 2.446-2.4 2.446l-.001 1.63M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0"
    />
  </svg>
);
export default SvgHelpCircleContained;
